import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useContext, useEffect } from 'react'
import { Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import AppContext from '../Authentication/AppContext'
import DialogContext from '../Authentication/DialogContext'
import LoginService from '../service/LoginService'

export const Logout: FC<{}> = () => {
  const { refreshAuthentication, refreshUserDetails } = useContext(AppContext)
  const { closeAllDialog } = useContext(DialogContext)
  const { t } = useTranslation()
  useEffect(() => {
    closeAllDialog()
    LoginService.logOut(refreshAuthentication, refreshUserDetails)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>Gateway [{t('logout')}]</title>
      </Helmet>
      <Col className=' mx-auto contain'>
        <div className='content'>
          <h1 className='mb-5'>
            <FontAwesomeIcon icon={faSignOutAlt} /> {t('logoutmessage')}
          </h1>
          <h1>
            Please click
            <Link to='/login' className='mx-2'>
              Login
            </Link>
            to login again.
          </h1>
        </div>
      </Col>
    </>
  )
}
